module.exports = __webpack_public_path__ + "static/media/google.335e6f0c.png";